import Vue from 'vue';

import store from './store';
import IntroduceDataApp from './views/ab-test/introduce-data-sheet.vue';
import IntroduceOpenCvApp from './views/ab-test/introduce-open-cv-sheet.vue';
import IntroduceInstructorApp from './views/ab-test/introduce-instructor-sheet.vue';
import PurchaseSheetNewApp from './views/ab-test/price-table-dark-app.vue';

const initPriceTableLayout = () => {
  const selector = '.price-table-dark-app';
  const apps = document.querySelectorAll(selector);
  const {
    courseId,
    coursePageId,
    discountPercent,
    hasProducts,
    listPrice,
    productDiscountAmount,
    productId,
    productSaleDueDate,
    productTitle,
    salePrice,
    splitPrice,
  } = document.getElementById('main').dataset;
  const mainProps = {
    courseId,
    coursePageId,
    discountPercent,
    hasProducts,
    listPrice,
    productDiscountAmount,
    productId,
    productSaleDueDate,
    productTitle,
    salePrice,
    splitPrice,
  };

  [...apps].forEach((app) => {
    const { buttonLabel } = app.dataset;
    const appProps = {
      buttonLabel,
    };

    app.parentElement.parentElement.style.backgroundColor = '#000';

    if (app) {
      new Vue({
        store,
        render: (h) => h(PurchaseSheetNewApp, { props: { ...mainProps, ...appProps } }),
      }).$mount(app);
    }
  });
};

const initDataOnlineLayout = (slug) => {
  const [introduceApp] = document.getElementsByClassName(`fc-introduce-data`);

  new Vue({
    store,
    render: (h) => h(IntroduceDataApp),
  }).$mount(introduceApp);

  const [introduceInstructorApp] = document.getElementsByClassName(`${slug} fc-introduce-instructor`);

  new Vue({
    store,
    render: (h) =>
      h(IntroduceInstructorApp, {
        props: {
          slug,
          subTitle: '퀀트 정복을 이끌어 주실 강사님',
          name: '이현열 강사님',
          career: `
            카이스트 금융공학 석사<br>
            한양대학교 재무금융 박사과정<br>
            CFA / FRM<br>
            전) NH 자산운용, 퀀트 매니저<br>
            저서) R을 이용한 퀀트 투자 포트폴리오 만들기<br>
            저서) 스마트베타<br>
          `,
          mention: `저서인 스마트베타, R을 활용한 퀀트 투자 포트폴리오 만들기와 블로그를\n
            통해 금융 데이터 분석과 이를 활용한 투자의 중요성을 강조합니다.\n
            현재 시중에서 퀀트를 주제로 강의중인 강사 중 유일하게 깃헙과 R 등을\n
            주력으로 사용하여, 관련 업계에서 일한 경력 등을 바탕으로 실전에 가장\n
            가까운 강의를 제공합니다.`,
        },
      }),
  }).$mount(introduceInstructorApp);
};

const initOpenCvLayout = (slug) => {
  const [introduceApp] = document.getElementsByClassName('fc-introduce-open-cv');

  new Vue({
    store,
    render: (h) => h(IntroduceOpenCvApp),
  }).$mount(introduceApp);

  const selector = `${slug} fc-introduce-instructor`;
  const [introduceInstructorApp] = document.getElementsByClassName(selector);

  new Vue({
    store,
    render: (h) =>
      h(IntroduceInstructorApp, {
        props: {
          slug,
          subTitle: '누구에게 어떻게 배우는 지가 중요합니다. 컴퓨터 비전 베스트셀러 저자 황선규 박사님 직강.',
          name: '황선규 박사님',
          career: `
            현) 한양대학교 영상 처리 전공 박사<br>
            현) IT 전문 강사, IT 전문서 저자, 프리랜서 개발자<br>
            전) 뉴질랜드 캔터베리 대학교 HIT Lab NZ PostDoc<br>
            전) 한양대학교 연구교수<br>
            전) LG전자 전략 스마트폰 카메라 기능 및 카메라<br>
            프레임워크 개발<br>
          `,
          mention: `안녕하세요, 「OpenCV 4로 배우는 컴퓨터 비전과 머신 러닝」 저자\n
            황선규입니다. 본 강의는 영상 데이터의 기본적인 처리 방법과 머신러닝과 딥러닝을 활용한 고급 컴퓨터 비전 이론까지 체계적으로 전달합니다.\n
            사용하기 쉬운 Python 언어와 OpenCV 라이브러리를 이용하여 쉽고\n
            빠르게 예제 프로그램을 만들고, 그 결과를 눈으로 확인할 수 있습니다. 잘\n
            짜여진 커리큘럼으로 구성된 수업이 컴퓨터 비전 실무자 뿐만 아니라 영상 처리에 관심이 있는 분들께 충분히 유익할 시간이 될 것입니다.`,
          link:
            'https://m.blog.naver.com/PostView.nhn?blogId=fastcampus&logNo=220807872936&proxyReferer=https:%2F%2Fwww.google.com%2F',
        },
      }),
  }).$mount(introduceInstructorApp);
};

export const initAbTestLayout = () => {
  initPriceTableLayout();
  initDataOnlineLayout('data_online_fin');
  initOpenCvLayout('dev_online_cvodl');
};
